var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.924 1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.736,104.914s69.259-57.363,109.149,0Z",
    transform: "translate(2.071 13.309)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.978,121.388c17.717,0,32.079-2.222,32.079-4.961s-14.363-4.962-32.079-4.962S82.9,113.687,82.9,116.427,97.262,121.388,114.978,121.388Z",
    transform: "translate(14.094 18.612)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.006,81.763a3.257,3.257,0,0,0,2.868-.325,3.206,3.206,0,0,0-.956-5.8,3.259,3.259,0,0,0-1.482-.031l.081,1.652-.788-1.416a3.208,3.208,0,0,0-1.66,1.808,3.09,3.09,0,0,0-.186.868,3.185,3.185,0,0,0,.514,1.975A3.226,3.226,0,0,0,127.006,81.763Z",
    transform: "translate(20.918 12.604)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.146,101.312c-.278-1.405.927-2.651,2.117-3.46s2.581-1.605,2.987-2.979c.584-1.975-1.154-3.783-2.508-5.343a19.334,19.334,0,0,1-2.568-3.788,5.205,5.205,0,0,1-.614-1.722,5.909,5.909,0,0,1,.462-2.581q1.428-4.172,3.051-8.275",
    transform: "translate(21.676 12.269)",
    fill: "none",
    stroke: "#57b894",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.743,72.968a3.2,3.2,0,0,1,.9-1.313,3.241,3.241,0,0,1,1.426-.722l.266,1.571.494-1.65a3.247,3.247,0,0,1,1.9.646,3.2,3.2,0,0,1-.108,5.206,3.254,3.254,0,0,1-3.813-.1,3.192,3.192,0,0,1-1.064-3.635Z",
    transform: "translate(21.678 11.823)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,88.138a3.257,3.257,0,0,0,2.3-.037,3.224,3.224,0,0,0,1.694-1.55,3.195,3.195,0,0,0-1.136-4.123l-.379,1.268-.269-1.589-.008,0a3.259,3.259,0,0,0-2.474.11,3.2,3.2,0,0,0,.267,5.925Z",
    transform: "translate(21.747 13.668)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.913,92.379a3.2,3.2,0,0,0,1.064,1.867,3.252,3.252,0,0,0,4.071.136,3.2,3.2,0,0,0-.548-5.448,3.25,3.25,0,0,0-3.964.932l1.442,2.153-1.969-1.143A3.168,3.168,0,0,0,128.913,92.379Z",
    transform: "translate(21.567 14.787)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.195,99.37a28.275,28.275,0,0,0,3.714-1.718c.86-.608,4.391-1.334,4.6-.359s4.289,4.849,1.066,4.874-7.487.525-8.346.006S126.195,99.37,126.195,99.37Z",
    transform: "translate(21.133 16.231)",
    fill: "#656380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.639,101.471c-3.223.026-7.488.524-8.346.006-.655-.4-.915-1.814-1-2.468l-.1,0s.181,2.284,1.039,2.8,5.125.02,8.346-.006c.931-.007,1.252-.336,1.235-.822C136.686,101.282,136.33,101.465,135.639,101.471Z",
    transform: "translate(21.133 16.587)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.063,73.345H13.5a2.459,2.459,0,0,0-2.469,2.45v27.761a2.459,2.459,0,0,0,2.469,2.45h7.561a2.459,2.459,0,0,0,2.469-2.45V75.794A2.459,2.459,0,0,0,21.063,73.345Z",
    transform: "translate(1.794 12.316)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.486,56.453H33.926a2.459,2.459,0,0,0-2.469,2.45v47.4a2.46,2.46,0,0,0,2.469,2.45h7.561a2.46,2.46,0,0,0,2.469-2.45V58.9A2.459,2.459,0,0,0,41.486,56.453Z",
    transform: "translate(5.267 9.547)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.916,44.718H54.355a2.459,2.459,0,0,0-2.469,2.45V108.21a2.459,2.459,0,0,0,2.469,2.45h7.561a2.459,2.459,0,0,0,2.469-2.45V47.168A2.459,2.459,0,0,0,61.916,44.718Z",
    transform: "translate(8.687 7.617)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.34,33.516H74.779a2.459,2.459,0,0,0-2.469,2.45v74.065a2.459,2.459,0,0,0,2.469,2.45H82.34a2.459,2.459,0,0,0,2.468-2.45V35.966A2.459,2.459,0,0,0,82.34,33.516Z",
    transform: "translate(12.106 5.765)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.766,13.958H95.2a2.459,2.459,0,0,0-2.469,2.45v96.8a2.459,2.459,0,0,0,2.469,2.45h7.561a2.459,2.459,0,0,0,2.469-2.45v-96.8A2.46,2.46,0,0,0,102.766,13.958Z",
    transform: "translate(15.526 2.269)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,71.922H14.937a2.459,2.459,0,0,0-2.468,2.45v27.761a2.46,2.46,0,0,0,2.468,2.45H22.5a2.46,2.46,0,0,0,2.468-2.45V74.372A2.459,2.459,0,0,0,22.5,71.922Z",
    transform: "translate(2.027 12.077)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.918,55.031H35.357a2.459,2.459,0,0,0-2.468,2.45v47.4a2.459,2.459,0,0,0,2.468,2.449h7.561a2.459,2.459,0,0,0,2.468-2.449V57.48A2.459,2.459,0,0,0,42.918,55.031Z",
    transform: "translate(5.506 9.307)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.348,43.3H55.787a2.459,2.459,0,0,0-2.468,2.45v61.042a2.459,2.459,0,0,0,2.468,2.449h7.561a2.459,2.459,0,0,0,2.468-2.449V45.745A2.459,2.459,0,0,0,63.348,43.3Z",
    transform: "translate(8.927 7.374)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.772,32.094H76.211a2.459,2.459,0,0,0-2.468,2.45v74.065a2.459,2.459,0,0,0,2.468,2.45h7.561a2.459,2.459,0,0,0,2.468-2.45V34.544A2.459,2.459,0,0,0,83.772,32.094Z",
    transform: "translate(12.346 5.52)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,12.535H96.636a2.459,2.459,0,0,0-2.468,2.45v96.8a2.46,2.46,0,0,0,2.468,2.45H104.2a2.459,2.459,0,0,0,2.468-2.45v-96.8A2.459,2.459,0,0,0,104.2,12.535Z",
    transform: "translate(15.766 2.038)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,101.455H0",
    transform: "translate(0 16.985)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.409,73.562s1.96,7-.522,8.041-1.7-7.781-1.7-7.781Z",
    transform: "translate(20.95 12.279)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.612,112.168a6.289,6.289,0,0,0-2.483.259,1.588,1.588,0,0,1-1.307.129s-2.875-.259-1.829,1.167,2.09,1.945,2.09,2.594,4.313.649,4.443,0,.262-4.02,0-4.149A2.071,2.071,0,0,0,112.612,112.168Z",
    transform: "translate(17.856 18.717)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,112.168a6.289,6.289,0,0,1,2.483.259,1.588,1.588,0,0,0,1.307.129s2.875-.259,1.829,1.167-2.09,1.945-2.09,2.594-4.313.649-4.443,0-.262-4.02,0-4.149A2.071,2.071,0,0,1,116.1,112.168Z",
    transform: "translate(19.319 18.717)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.262,72.544s-.915,20.491-.392,21.529,2.352,18.546,2.09,19.583-1.568,5.318,0,5.966,4.967,0,4.967,0,.915-5.187.522-7.911-.522-14.136-.522-14.136l2.613-11.931.915,11.283s.262,15.433-1.568,18.546.653,4.41.653,4.41,4.967.649,5.489.519-.392-5.187,0-7.392,1.307-14.526,2.091-17.509,5.227-19.583,1.96-22.955S107.262,72.544,107.262,72.544Z",
    transform: "translate(17.965 12.041)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.029,38.019a4.539,4.539,0,1,0-4.574-4.539A4.557,4.557,0,0,0,116.029,38.019Z",
    transform: "translate(18.737 4.832)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.467,34.684s.784,6.225.392,6.355,6.927,0,6.927,0-1.438-3.761,0-6.744Z",
    transform: "translate(18.901 5.723)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.467,39.174a5.1,5.1,0,0,1,6.95,0l.244.928-1.967-.02h-5.227Z",
    transform: "translate(18.901 6.301)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.355,78.858c-.3.06-1.042.182-2.005.327-3.211.481-8.9,1.21-9.1.711-.26-.648-1.175-2.983-1.829-1.945s-.262,1.945-3.006,2.075a22.724,22.724,0,0,1-6.084-.612c-.706-.2-1.145-.436-1.1-.685.13-.778,1.568-15.563,1.568-16.989s.522-8.3.522-8.3L104.559,46.1l-.3-.577s.392-1.427,1.568-1.686,6.8-3.5,6.8-3.5a3.985,3.985,0,0,1,3.4-1.686c2.222.13,2.745-.778,5.75,1.686,0,0,3.66,1.556,4.967,2.334s2.745.778,2.875,2.075a3.935,3.935,0,0,1-.36,1.4,76.678,76.678,0,0,1-3.512,7.077l-.048.086s-.069,2.332,0,5.062v.006a32.62,32.62,0,0,0,.78,7.252C127.525,69,130.662,78.6,129.355,78.858Z",
    transform: "translate(17.567 6.499)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.176,32.057a3.08,3.08,0,0,0-.517-1.146,6.147,6.147,0,0,0-.931-2.668,2.812,2.812,0,0,0-.835-.956,2.479,2.479,0,0,0-1.314-.325c-.083,0-.233.024-.369.03-.086-.027-.173-.05-.26-.072-.051-.113-.152-.441-.18-.419l-.381.3c-.16-.028-.323-.049-.486-.067-.059-.168-.117-.335-.177-.5a3.435,3.435,0,0,0-.252.47c-.162-.008-.323-.011-.486-.008l-.323-.309a.456.456,0,0,1-.358.347c-.149.015-.3.035-.445.059h-.036a4.022,4.022,0,0,0-2.323.379,2.281,2.281,0,0,0-.739.833c-.081.055-.164.11-.243.168a2.651,2.651,0,0,0-.685.673,2.855,2.855,0,0,0-.3.728,6.947,6.947,0,0,0-.349,2.384,3.528,3.528,0,0,0,.877,2.208c.342.365.778.634,1.12,1,.706.75.838,1.8,1.442,2.59a4.568,4.568,0,0,0,2.825,1.55,4.748,4.748,0,0,0,3.517-.87,2.155,2.155,0,0,0,.6-.623,6.3,6.3,0,0,0,.337-2.067C121.145,34.447,122.393,33.359,122.176,32.057Z",
    transform: "translate(18.53 4.383)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.825,73.9s1.961,7-.522,8.041-1.7-7.781-1.7-7.781Z",
    transform: "translate(17.296 12.335)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.01,62.774s-.857,12.627-.725,15.669c-.706-.2-1.144-.436-1.1-.685.13-.778,1.568-15.563,1.568-16.989s.522-8.3.522-8.3l-3.755-7.334c.059-.363.1-.577.1-.577l1.9,3.955,2.679.713Z",
    transform: "translate(17.473 7.485)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.515,43.889l-.915.778s-1.175,6.874-1.045,8.56-2.744,27.235-.522,27.235,4.7-.389,4.312-1.3S108,62.883,108,62.883l1.178-13.547Z",
    transform: "translate(17.09 7.378)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.252,45.34a76.676,76.676,0,0,1-3.512,7.077c.01-1.659.017-2.832.017-2.832l2.744-5.577.588-.454S126.152,44.24,126.252,45.34Z",
    transform: "translate(20.571 7.271)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.371,76.091c-.3.06-1.042.182-2.007.327-.5-3.673-1.838-14.235-1.753-15.23.042-.49.077-2.913.1-5.578a32.483,32.483,0,0,0,.78,7.252C124.541,66.235,127.678,75.832,126.371,76.091Z",
    transform: "translate(20.55 9.308)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.673,43.108l1.96.519s1.307,14.4,1.437,16.86,1.7,17.638,1.438,18.286-4.313,1.556-4.443.908-2.031-15.281-1.93-16.459-.553-13.369-.553-13.369Z",
    transform: "translate(20.546 7.248)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.752,70.791,41.5,51.154,65.452,37.717,89.2,24.694,112.945,1.956",
    transform: "translate(2.886 0.318)",
    fill: "none",
    stroke: "#575a89",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.071,63.757a2.274,2.274,0,1,0-2.291-2.274A2.283,2.283,0,0,0,18.071,63.757Z",
    transform: "translate(2.565 9.876)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,46.865a2.274,2.274,0,1,0-2.291-2.274A2.283,2.283,0,0,0,38.5,46.865Z",
    transform: "translate(6.053 7.059)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,35.308a2.274,2.274,0,1,0-2.291-2.274A2.283,2.283,0,0,0,59.1,35.308Z",
    transform: "translate(9.498 5.131)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,24.106a2.274,2.274,0,1,0-2.291-2.274A2.283,2.283,0,0,0,79.524,24.106Z",
    transform: "translate(12.911 3.18)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.953,4.548a2.274,2.274,0,1,0-2.291-2.274A2.283,2.283,0,0,0,99.953,4.548Z",
    transform: "translate(16.327)",
    fill: "#575a89"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.52a46afe97bddf9fc893b332478864d8.svg";
export { ForwardRef as ReactComponent };